import CarefulEditingIcon from './careful-editing.png';
import MultiFormatDeliveryIcon from './multi-format-delivery.png';
import PostLaunchSupportIcon from './post-launch-support.png';
import SmartPositioningIcon from './smart-positioning.png';
import TangibleResultsIcon from './tangible-results.png';
import SmoothProcessIcon from './smooth-process.png';

export { CarefulEditingIcon, MultiFormatDeliveryIcon, PostLaunchSupportIcon, SmartPositioningIcon, TangibleResultsIcon, SmoothProcessIcon };